export default "__VITE_ASSET__DlN298Ts__"